import { render, staticRenderFns } from "./RipaFormSummaryDetail.vue?vue&type=template&id=6856a87f"
import script from "./RipaFormSummaryDetail.vue?vue&type=script&lang=js"
export * from "./RipaFormSummaryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports